import React, { useRef } from "react";
import DatePicker from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import arabic from "react-date-object/calendars/arabic";
import persian from "react-date-object/calendars/persian";
import indian from "react-date-object/calendars/indian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian_ar from "react-date-object/locales/gregorian_ar";
import arabic_en from "react-date-object/locales/arabic_en";
import arabic_ar from "react-date-object/locales/arabic_ar";
import persian_en from "react-date-object/locales/persian_en";
import persian_ar from "react-date-object/locales/persian_ar";
import indian_en from "react-date-object/locales/indian_en";
import indian_ar from "react-date-object/locales/indian_ar";
import CalendarIcon from "../../assets/calendarIcon.svg";
import { ConfigProvider, Radio } from "antd";
import './Calendar.scss'

export interface CalendarProps {
  format?: string
  rtl?: boolean
  lang?: string
  headingLeft?: string
  headingRight?: string
  inputClass?: string
  value?: any
  onClick?: Function | any
  placeholder?: string
  onChange?: Function | any
  multiple?: boolean
  calanderTypes?: string[] | any;
  weekStartDayIndex?: number
  style?: any
  range?: boolean
  id?: string
  minDate?: Date
  maxDate?: Date
  disabled?: boolean
  numberOfMonths?: number
  width?: string
}

export const Calendar = ({
  value,
  onClick,
  placeholder = "Select Date",
  format = "DD/MM/YYYY",
  rtl,
  lang,
  headingLeft,
  headingRight,
  inputClass,
  onChange,
  multiple,
  calanderTypes,
  weekStartDayIndex,
  style,
  range,
  id,
  minDate,
  maxDate,
  disabled,
  numberOfMonths,
  width,
  ...props
}: CalendarProps) => {
  const textAlign = rtl ? 'right' : 'left';
  const dir = rtl ? 'rtl' : 'ltr';

  const [rbvalue, setRBValue] = React.useState("gregorian");
  const [calendar, setCalendar] = React.useState(gregorian);
  const [locale, setLocale] = React.useState(lang === 'ar' ? gregorian_ar : gregorian_en);
  const datePickerRef: any = useRef()

  const onTypeChange = (e: any) => {
    setRBValue(e.target.value);

    if (e.target.value === "arabic") {
      setCalendar(arabic);
      setLocale(lang === 'ar' ? arabic_ar : arabic_en);
    }
    if (e.target.value === "gregorian") {
      setCalendar(gregorian);
      setLocale(lang === 'ar' ? gregorian_ar : gregorian_en);
    }
    if (e.target.value === "persian") {
      setCalendar(persian);
      setLocale(lang === 'ar' ? persian_ar : persian_en);
    }
    if (e.target.value === "indian") {
      setCalendar(indian);
      setLocale(lang === 'ar' ? indian_ar : indian_en);
    }
    setTimeout(() => {
      datePickerRef?.current?.openCalendar()
    }, 10)
  };

  function MyPlugin({ calanderTypes }: any) {
    return (<div>
      {calanderTypes?.length > 0 ?
        <div className="radio-container">
          <Radio.Group value={rbvalue} size="large" onChange={onTypeChange}>
            {calanderTypes.map((op: any) => {
              return <Radio.Button value={op.type} key={op.type}>{op.label}</Radio.Button>
            })}
          </Radio.Group>
        </div> : null}
    </div>)
  }

  return (
    <>
      <ConfigProvider direction={dir}>
        <div className='notify__calendar--container' style={{ float: textAlign, width, textAlign }}>
          <div className={rtl ? 'heading-section floatRtl' : 'heading-section'}>
            <div className='heading-left'>{headingLeft !== '' ? headingLeft : ''}</div>
            <div className='heading-right'>{headingRight !== '' ? headingRight : ''}</div>
          </div>
          <div className="calendar-main">
            <DatePicker
              placeholder={placeholder}
              inputClass={inputClass ? inputClass : "custom-input"}
              containerStyle={{
                width: "100%"
              }}
              calendarPosition="bottom-center"
              weekStartDayIndex={weekStartDayIndex}
              calendar={calendar}
              locale={locale}
              format={format}
              arrow={false}
              value={value}
              onChange={onChange}
              multiple={multiple}
              showOtherDays={true}
              style={style}
              range={range}
              id={id}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              numberOfMonths={numberOfMonths}
              editable={false}
              // @ts-ignore
              plugins={[<MyPlugin position="top" calanderTypes={calanderTypes} />]}
              ref={datePickerRef}
            />
            <label htmlFor={id}>
              <div className={rtl ? "calendar-icon ci-right" : "calendar-icon"}>
                <img src={CalendarIcon} alt='calendar-icon' />
              </div>
            </label>
          </div>
        </div>
      </ConfigProvider>
    </>
  );
}